import Inventory from 'locales/dental/en/warehouses/inventory.json'
import Adjustment from 'locales/dental/en/warehouses/adjustment.json'
import medicine from 'locales/dental/en/warehouses/medicine.json'
import product from 'locales/dental/en/warehouses/product.json'
import importProduct from 'locales/dental/en/warehouses/import-product.json'

const Warehouses = {
  ...Inventory,
  ...Adjustment,
  ...medicine,
  ...product,
  ...importProduct
}

export default Warehouses
